import { debounce } from 'lodash-es';

import { Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { AccreditationTestimonial } from '~/features/accreditation/types';
import { trackEvent } from '~/features/analytics/track-event';
import { FormalDegreeKey } from '~/features/checkout/constants';
import { SectionHeader } from '~/features/experiments/ab_plp_redesign_2025/components/section-header';
import { TestimonialCarousel } from '~/features/experiments/ab_plp_redesign_2025/components/testimonials-carousel';

export function AccreditationTestimonialsSection({
  testimonials,
  formalDegreeKey,
}: {
  testimonials: AccreditationTestimonial[];
  formalDegreeKey?: FormalDegreeKey;
}) {
  const handleInteraction = debounce(() => {
    trackEvent({
      name: 'Masters Page CTA Clicked',
      type: 'click',
      label: 'testimonial_scroll_clicked',
      additionalAttributes: {
        formal_degree_key: formalDegreeKey,
      },
    });
  }, 100);
  return (
    <Flex as='section' flexDirection='column' gap={{ base: '56px', md: '72px' }}>
      <ContentContainer margin='0 auto' width='100%'>
        <SectionHeader
          color='grey.500'
          descriptionSlot={
            <Text color='grey.500'>
              Hear from Udacity students who turned their skills into a lasting impact on their careers.
            </Text>
          }
          titleSlot={
            <Heading as='h2' size={{ base: 'mobile-heading-3', md: 'heading-3' }}>
              Real learners. Real career transformations
            </Heading>
          }
        />
      </ContentContainer>
      <TestimonialCarousel testimonials={testimonials} onInteraction={handleInteraction} />
    </Flex>
  );
}
